export const GUEST_QMS_TOKEN_KEY = 'oujat-guest-qms-token'
export const GUEST_QMS_PENDING_SUBMIT_KEY = 'oujat-guest-qms-pending-submit'
export const POST_AUTH_REDIRECT_KEY = 'oujat-post-auth-redirect'

export function setPostAuthRedirect(path) {
  if (path && typeof window !== 'undefined') {
    window.localStorage.setItem(POST_AUTH_REDIRECT_KEY, path)
  }
}

export function consumePostAuthRedirect() {
  if (typeof window === 'undefined') return null
  const value = window.localStorage.getItem(POST_AUTH_REDIRECT_KEY)
  if (value) {
    window.localStorage.removeItem(POST_AUTH_REDIRECT_KEY)
  }
  return value
}

export function getGuestDraftToken(searchParams) {
  if (typeof searchParams?.get === 'function') {
    const fromUrl = searchParams.get('guestDraft')
    if (fromUrl) return fromUrl
  }
  if (typeof window !== 'undefined') {
    return window.localStorage.getItem(GUEST_QMS_TOKEN_KEY) || ''
  }
  return ''
}

export function isGuestQmsRoute(pathname, search = '') {
  if (pathname !== '/qms/create-qms') return false
  const params = new URLSearchParams(search)
  return Boolean(params.get('guestDraft') || (typeof window !== 'undefined' && window.localStorage.getItem(GUEST_QMS_TOKEN_KEY)))
}

export function persistGuestDraftToken(token) {
  if (token && typeof window !== 'undefined') {
    window.localStorage.setItem(GUEST_QMS_TOKEN_KEY, token)
  }
}

export function clearGuestDraftToken() {
  if (typeof window !== 'undefined') {
    window.localStorage.removeItem(GUEST_QMS_TOKEN_KEY)
  }
}

export function clearGuestQmsSession() {
  clearGuestDraftToken()
  if (typeof window !== 'undefined') {
    window.localStorage.removeItem(GUEST_QMS_PENDING_SUBMIT_KEY)
  }
}

export function hasGuestPendingSubmit() {
  if (typeof window === 'undefined') return false
  return window.localStorage.getItem(GUEST_QMS_PENDING_SUBMIT_KEY) === 'true'
}

export function clearGuestPendingSubmit() {
  if (typeof window !== 'undefined') {
    window.localStorage.removeItem(GUEST_QMS_PENDING_SUBMIT_KEY)
  }
}
